import React, {useEffect} from 'react';
import {ActionModal, ErrorModal, useErrorHandler} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {useBlockStoryById} from '../../../../entities';

interface DeleteStoryModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  blockId: string;
  storyId: string;
}

export const DeleteStoryModal = ({open, setOpen, blockId, storyId}: DeleteStoryModalProps) => {
  const {deleteStoryMutation} = useBlockStoryById(blockId, storyId);

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'История',
    title: 'Ошибка при удалении истории',
  });

  useEffect(() => {
    if (deleteStoryMutation.error) {
      handleError(deleteStoryMutation.error as unknown as ApiError);
    }
  }, [deleteStoryMutation.error, handleError]);

  const handleDeleteStory = async () => {
    try {
      await deleteStoryMutation.mutateAsync({blockId, storyId});
      setOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleDeleteStory}
        isLoading={deleteStoryMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Удаление истории'}
        textButtonApply={'Удалить'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          Вы уверены, что хотите удалить эту историю? Обратите внимание, что это действие безвозвратное
        </Text>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
